define('model/AdaCompliantModuleModel',['require','backbone','Config','lib/model/BaseModel'],function (require) {
    var Backbone = require('backbone');
    var Config = require('Config');
    var BaseModel = require('lib/model/BaseModel');
    /**
     * GdprReportModuleModel
     *
     * @class MenuModel
     */
    return BaseModel.extend({

        url: '/v2/ada/info',

        defaults: {
            //plugins: {},
        },

        initialize: function () {
            var _this = this;
            this.set('enabled', this._isAllowSwitchToAda());

            this.listenTo(Config.getInstance(), 'config:changed', function(){
                if(_this._isAllowSwitchToAda() !== this.get('enabled')){
                    this.set('enabled', _this._isAllowSwitchToAda());
                }
            });

            this.validators = {
            };
            BaseModel.prototype.initialize.call(this);
        },

        _isAllowSwitchToAda : function (){
            return !!parseInt(Config.getInstance().getOption('allow_switch_to_ada'));
        },

        validate: function () {
            var errors = BaseModel.prototype.validate.apply(this, arguments);
            return errors;
        },


    }, {

        instance: null,

        getInstance: function () {
            if (!this.instance) {
                this.instance = new this();
            }
            return this.instance;
        }

    });

});
